import React, {useEffect, useMemo, useState} from 'react';
import {HStack, VStack, Text as NBText} from "native-base";
import AppText from "../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../styles/GlobalStyles";
import {t} from "../../../../../services/i18n";
import AdvanceSelect from "../../../../common/AdvanceSelect";
import {Colors} from "../../../../../styles/Colors";
import {
    autoMessageTypesObj,
    EMAIL,
    PUSH,
    SMS,
    WHATSAPP
} from "../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../services/HTTP";
import usePermissions from "../../../../../services/Permissions";
import MessageTextFormInput from "../../../../common/MessageTextFormInput";
import {useSelector} from "react-redux";
import SimpleInput from "../../../../common/SimpleInput";
import CustomSwitch from "../../../../common/CustomSwitch";
import {Divider} from "antd";
import {getSessionAutoMessageTags, isMobile} from "../../../../../services/Helpers";
import DropDownMenu from "../../../../common/DropDownMenu";
import {
    autoMessageTimeUnits,
    autoMessageTypes,
    getIsMessageTypeActive
} from "../../../Schedule/Popups/ScheduleSettings/SettingsConfig";
import InfoTooltip from "../../../../common/InfoTooltip";
import CustomCheckbox from '../../../../common/CustomCheckbox';

const SessionAutoMessage = (props) => {
    const { values, errors, setFieldValue, touched, validationSchema, allowTimeSelection, showCheckInSection, showDigitalFormSection, periodAmountTextBefore, periodAmountTextAfter, isReminder, showAfterSessionSection, hiddenMessageTypes = [], hideActiveToggle} = props;
    const box = useSelector(state => state.box?.box)
    const hasWhatapp = box?.integrations?.find(i => i.name === 'upgrade360' || i.name === 'greenApi' || i.name === 'metaWhatsapp')

    const [smsBalance, setSmsBalance] = useState(null);
    const [formOptions, setFormOptions] = useState([]);
    const { has, hasLock } = usePermissions()

    const isIL = useMemo(() => box?.locations_box[0]?.country_code === 'IL', [box]);
    const smsUnitCount = isIL ? 133 : 70;
    const maxCharCount = values.type?.some(item => item.id === PUSH) ? 175 : 1000;
    const charCount = useMemo(() => values?.message_content?.length ?? 0,[values?.message_content]);
    const hasMetaWhatsapp = useMemo(() => !!box?.integrations?.some(i => i.name === 'metaWhatsapp'), [box]);
    const isWhatsappSelected = useMemo(() => !!values.type?.some(item => item.id === WHATSAPP), [values.type]);
    const tags = useMemo(() => {
        const sessionTags = getSessionAutoMessageTags(values.actionName, box.locations_box.length > 1, values.session_type);
        if (!hasMetaWhatsapp || !isWhatsappSelected) return sessionTags;
        return sessionTags.map(tag => tag.id === 'confirmation_link' ? {...tag, tooltip: t('confirmation-link-whatsapp-button-tooltip')} : tag);
    }, [values.actionName, values.session_type, hasMetaWhatsapp, isWhatsappSelected]);
    const messageTypes = useMemo(() => {
        let options = [autoMessageTypesObj({})[PUSH]];
        if(has(`${EMAIL}Actions`) && !hasLock(`${EMAIL}Actions`)) options.push(autoMessageTypesObj({})[EMAIL])
        if(has(`${SMS}Actions`) && !hasLock(`${SMS}Actions`)) options.push(autoMessageTypesObj({smsBalance})[SMS])
        if(hasWhatapp) options.push(autoMessageTypesObj({})[WHATSAPP])
        if(hiddenMessageTypes && hiddenMessageTypes.length > 0) options = options.filter(item => !hiddenMessageTypes.includes(item.id))
        return options
    }, [smsBalance, hiddenMessageTypes]);
    const timeUnitOptions = useMemo(() => Object.keys(autoMessageTimeUnits).map((item) => ({id: item, name: t(`${item.toLowerCase()}s`)})),[])
    const autoActions = useSelector(state => state.box.box.auto_actions)
    const existingSecondReminder = useMemo(() => autoActions.filter(item => item.auto_actions.action === autoMessageTypes.SECOND_REMINDER_SESSION && item.active === 1 && item.session_type === values.session_type), [autoActions, values.session_type])
    const existingFirstReminder = useMemo(() => autoActions.filter(item => item.auto_actions.action === autoMessageTypes.REMINDER_SESSION && item.active === 1 && item.session_type === values.session_type), [autoActions, values.session_type])

    useEffect(() => {
        getSmsBalance()
        getDigitalForms()
    }, []);

    const getSmsBalance = async () => {
        const res = await fetchApi('boxes/getSmsBalance', 'POST', null, false, true);
        if(values?.type?.some(item => item.id === SMS)) {
            const newTypes = values.type.map(item => item.id === SMS ? autoMessageTypesObj({smsBalance: res})[SMS] : item);
            setFieldValue('type', newTypes)
        }
        setSmsBalance(res || 0);
    }

    const getDigitalForms = async () => {
        const res = await fetchApi('digitalForm/getAllForms', 'GET', null, false, true);
        if(res && res.length) {
            setFormOptions(res.map(df => ({...df, value: df.id, label: df.name})))
        }
    }

    const getInputLabel = (name, label) => {
        if(validationSchema && validationSchema.fields[name] && validationSchema.fields[name].spec?.presence === 'required') {
            return `${label}*`
        }
        return label
    }

    const onTagClick = (label) => {
        if (`${values.message_content || ''} [${label}]`.length <= maxCharCount) {
            setFieldValue('message_content', `${values.message_content || ''}[${label}]`)
        }
        document?.getElementById('text-area-message')?.focus()
    }


    return (
        <VStack space={'0.8rem'}>
            {!hideActiveToggle &&
            <HStack justifyContent={'space-between'} alignItems={'center'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} mediumFont={!isMobile} boldFont={isMobile}>{t('active-reminder')}</AppText>
                <CustomSwitch isChecked={values.active} onToggle={(val) => setFieldValue('active', val)}/>
            </HStack>}
            {allowTimeSelection && values.active &&
                <VStack>
                    <HStack space={'0.5rem'} alignItems={'center'} style={{flexFlow: 'wrap', rowGap: '0.2rem'}}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{periodAmountTextBefore || t('period-amount-text-before')}</AppText>
                        <HStack space={'0.5rem'} alignItems={'center'}>
                            <SimpleInput value={values.period_amount}
                                         onChangeCallback={(val) => setFieldValue('period_amount', val)}
                                         numericOnly={true}
                                         width={'4rem'}
                                         status={errors.period_amount && touched.period_amount ? 'error' : null}
                            />
                            <DropDownMenu title={t(`${values.period_time_unit?.toLowerCase()}s`)}
                                          items={timeUnitOptions}
                                          onPress={(val) => setFieldValue('period_time_unit', val)}
                                          showBorder={true}
                                          styleOverride={{height: '30px', width: '4.5rem'}}
                                          fontSize={GlobalStyleAttributes.fonts.standard16}
                            />
                            <HStack alignItems={'center'}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{periodAmountTextAfter || t('period-amount-text-after')}</AppText>
                                {isReminder && (values.actionName === autoMessageTypes.REMINDER_SESSION ? <InfoTooltip title={existingSecondReminder.length ? t('sec-reminder-active-info', {
                                    period_amount: existingSecondReminder[0].period_amount,
                                    period_time_unit: t(`${existingSecondReminder[0].period_time_unit?.toLowerCase()}s`)
                                }) : t('sec-reminder-inactive-info')}/> :
                                    <InfoTooltip title={t('first-reminder-active-info', {
                                        period_amount: existingFirstReminder[0].period_amount,
                                        period_time_unit: t(`${existingFirstReminder[0].period_time_unit?.toLowerCase()}s`)
                                    })}/>
                                )}
                            </HStack>
                        </HStack>
                    </HStack>
                    {touched.period_amount && errors.period_amount && <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{errors.period_amount}</AppText>}
                </VStack>
            }
            {showCheckInSection && values.active &&
                <VStack space={'0.2rem'}>
                    <HStack space={'0.5rem'} alignItems={'center'}>
                        <AppText>{t('check-in-reminder-before')}</AppText>
                        <SimpleInput value={values.period_amount}
                                     onChangeCallback={(val) => setFieldValue('period_amount', val)}
                                     onBlur={() => setFieldValue('period_amount', values.period_amount - (values.period_amount % 5))}
                                     numericOnly={true}
                                     width={'4rem'}
                                     step={5}
                                     min={5}
                                     max={60}
                                     status={errors.period_amount ? 'error' : null}
                        />
                        <AppText>{t('check-in-reminder-after')}</AppText>
                    </HStack>
                    <CustomCheckbox text={t('only-when-unchecked')} isChecked={values.count} onChange={(val) => setFieldValue('count', Number(val))}/>
                </VStack>
            }
            {showAfterSessionSection && values.active &&
                <VStack space={'0.2rem'}>
                    <HStack space={'0.5rem'} alignItems={'center'} style={{flexFlow: 'wrap', rowGap: '0.2rem'}}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('after-session-period-amount-before')}</AppText>
                        <SimpleInput value={values.period_amount}
                                     onChangeCallback={(val) => setFieldValue('period_amount', val)}
                                     numericOnly={true}
                                     width={'4rem'}
                                     min={0}
                                     status={errors.period_amount && touched.period_amount ? 'error' : null}
                        />
                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('after-session-period-amount-after')}</AppText>
                    </HStack>
                    {touched.period_amount && errors.period_amount && <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{errors.period_amount}</AppText>}
                    <CustomCheckbox text={
                        <HStack alignItems={'center'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.mainText}>{t('after-session-only-when-checked-in')}</AppText>
                            <InfoTooltip title={t('after-session-only-when-checked-in-tooltip')}/>
                        </HStack>
                    } isChecked={!!values.count} onChange={(val) => setFieldValue('count', Number(val))}/>
                </VStack>
            }
            {!hideActiveToggle && <Divider orientation="horizontal" h={'1px'} w={'100%'} bg={Colors.borderColor} style={{marginBlock: '0.3rem'}}/>}
            {isMobile && <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('edit-template')}</AppText>}
            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{getInputLabel('type', t('send-via'))}</AppText>
                <AdvanceSelect options={messageTypes}
                               isMulti={true}
                               onChange={(val) => setFieldValue('type', val)}
                               value={values?.type}
                               closeMenuOnSelect={false}
                />
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error}>{errors.type}</AppText>
            </VStack>
            {(has(`${EMAIL}Actions`) && !hasLock(`${EMAIL}Actions`)) &&
            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('subject')}</AppText>
                <SimpleInput value={values.subject}
                             onChangeCallback={(val) => setFieldValue('subject', val)}
                             error={(touched.subject && errors.subject) || null}
                             width={'100%'}
                             maxLength={40}
                             showCount
                             placeholder={t('subject-placeholder')}
                />
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error}>{errors.subject}</AppText>
            </VStack>}
            {showDigitalFormSection && <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{getInputLabel('digital_form_id', t('form-name'))}</AppText>
                <AdvanceSelect options={formOptions}
                               initValue={values.digital_form_id}
                               onChange={(val) => setFieldValue('digital_form_id', val?.id ?? null)}
                               isClearable={true}/>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error}>{errors.digital_form_id}</AppText>
            </VStack>}
            <MessageTextFormInput {...{tags, onTagClick, setFieldValue, values, maxLength: maxCharCount, smsUnitCount,
                touched, errors, name: 'message_content', placeholder: t('add-message-here'), id: 'text-area-message',
                isSms: values.type?.some(item => item.id === SMS), showDigitalFormText: values.digital_form_id, charCount, maxCharCount, absoluteCharCount: true}} containerProps={{mb: '1rem'}}/>
        </VStack>
    );
};

export default SessionAutoMessage;